import { render } from "./adjustQuantityModel.vue?vue&type=template&id=1c4e19da"
import script from "./adjustQuantityModel.vue?vue&type=script&lang=js"
export * from "./adjustQuantityModel.vue?vue&type=script&lang=js"

import "./adjustQuantityModel.vue?vue&type=style&index=0&id=1c4e19da&lang=sass"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__